import { render, staticRenderFns } from "./IconTrendingDownOutline.vue?vue&type=template&id=869fb45a"
import script from "./IconTrendingDownOutline.vue?vue&type=script&lang=js"
export * from "./IconTrendingDownOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports